import React, { ReactNode } from 'react'
import { Parameter, ParameterType } from './apireftypes';
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { Util } from '../fasades/util';
import { ApiRef } from '../fasades/apiref';
import './apiendpoint.css';

interface Props {
    parameter : Parameter;
}

interface State
{
    show              : boolean;
    showNestedMembers : boolean;
}

export class ApiParameter extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            show              : Util.isPrerendering(),
            showNestedMembers : false
        };
    }

    handleShowHide()
    {
        this.setState( { show : !this.state.show } );
    }

    handleShowNestedMembers()
    {
        this.setState( { showNestedMembers : !this.state.showNestedMembers } );
    }

    getReferencedType() : { type: ParameterType, hasParameters: boolean } | null
    {
        try {
            const typeName = this.props.parameter.type.endsWith("[]") 
                ? this.props.parameter.type.substring(0, this.props.parameter.type.length - 2)
                : this.props.parameter.type;

            const referencedType = ApiRef.getType(typeName);
            const hasParameters = referencedType.parameters !== undefined && referencedType.parameters.length > 0;

            return { type: referencedType, hasParameters };
        } catch (e) {
            return null;
        }
    }

    render() {
        const icon = this.state.show ? IoIosArrowDown : IoIosArrowForward;
        const referencedType = this.getReferencedType();
        const nestedIcon = this.state.showNestedMembers ? IoIosArrowDown : IoIosArrowForward;

        return (
            <div className="parameter">
                <hr/>
                <div className="parameterTitle" onClick = { () => { this.handleShowHide() } } >
                    { React.createElement(icon as React.ComponentType) }
                    <span className="parameterName">{ this.props.parameter.name }</span>
                    <span className="parameterSepartor">:</span>
                    { this.renderType() }
                </div>
                { this.state.show && (
                    <>
                        <div className="parameterDescription">{this.props.parameter.description }</div>
                        { referencedType && referencedType.hasParameters && (
                            <div className="parameterDescription">
                                <div 
                                    className="parameterTitle" 
                                    onClick={ () => { this.handleShowNestedMembers() } }
                                    style={{ cursor: 'pointer', marginTop: '0.5rem', marginLeft: '1rem' }}
                                >
                                    { React.createElement(nestedIcon as React.ComponentType) }
                                    <span className="parameterName" style={{ fontStyle: 'italic' }}>
                                        { referencedType.type.name } members
                                    </span>
                                </div>
                                { this.state.showNestedMembers && (
                                    <div style={{ marginLeft: '1rem' }}>
                                        { referencedType.type.parameters!.map((param: Parameter) => (
                                            <ApiParameter key={param.name} parameter={param} />
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </>
                )}
            </div>
        )
    }

    renderType() : ReactNode
    {
        const opt = this.props.parameter.optional ? "optional " : "required ";

        if (this.props.parameter.type.endsWith("[]")) {
            const coreType = this.props.parameter.type.substring(0, this.props.parameter.type.length -2);
            return (
                <>
                  <span>{opt}</span>
                  <span>Array of </span>
                  <span className="parameterType">{ coreType }</span>
                </>);
        }
        else {
            return (
                <>
                <span>{opt}</span>
                <span className="parameterType">{ this.props.parameter.type }</span>
                </>);
        }
    }
}

